export const ContactUsListConstants = {
    GET_SUPPORT_LIST_REQUEST: "GET_SUPPORT_LIST_REQUEST",
    GET_SUPPORT_LIST_SUCCESS: "GET_SUPPORT_LIST_SUCCESS",
    GET_SUPPORT_LIST_FAILURE: "GET_SUPPORT_LIST_FAILURE",

    GET_REPLYTICKETADMIN_REQUEST:"GET_REPLYTICKETADMIN_REQUEST",
    GET_REPLYTICKETADMIN_SUCCESS:"GET_REPLYTICKETADMIN_SUCCESS",
    GET_REPLYTICKETADMIN_FAILURE:"GET_REPLYTICKETADMIN_FAILURE",

    GET_MESSAGEONSUPPORT_LIST_REQUEST: "GET_MESSAGEONSUPPORT_LIST_REQUEST",
    GET_MESSAGEONSUPPORT_LIST_SUCCESS: "GET_MESSAGEONSUPPORT_LIST_SUCCESS",
    GET_MESSAGEONSUPPORT_LIST_FAILURE: "GET_MESSAGEONSUPPORT_LIST_FAILURE",



}